import React from 'react';
import { motion } from 'framer-motion';
export function AgitationSection() {
  return <section className="py-24 px-6 bg-brand-cream" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-brand-purple mb-10 leading-tight" data-id="element-29">
          Lo peor no es dónde estás hoy. Es seguir igual en 2 años.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl font-sans text-gray-800 leading-relaxed mb-12" data-id="element-30">
          Cada mes que pasás sin un sistema profesional es un mes en el que otra
          esteticista en tu zona se diferencia, sube sus precios y llena su
          agenda. El conocimiento técnico ya lo tenés. Lo que falta es el
          sistema.
        </motion.p>

        <motion.blockquote initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="pl-6 border-l-4 border-brand-gold py-2" data-id="element-31">
          <p className="text-xl md:text-2xl font-serif italic text-brand-purple leading-relaxed" data-id="element-32">
            "Una esteticista sin sistema trabaja el doble y gana la mitad que
            una con sistema. La diferencia no es el talento — es la estructura."
          </p>
        </motion.blockquote>
      </div>
    </section>;
}